import React from 'react';
import { Card, CardTitle } from '../../style/ModalDesignacao.styles';

const EmptyState = ({ message }) => (
  <Card style={{ margin: '24px 32px 0 32px', textAlign: 'center' }}>
    <CardTitle>{message}</CardTitle>
  </Card>
);

export default EmptyState;
